import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

// Styles
import classes from './Info.scss'

// Actions
import { userActions } from 'redux/actionCreators'

// Components
import { FormGroup, Loader } from 'components'

// Helpers
import _get from 'lodash.get'

const FIELD_NAMES = ['contactPersonName', 'address', 'mobile']
const mapStateToProps = (state) => ({
  me: _get(state, ['user', 'me']),
  editProfileAttempting: _get(state, ['user', 'editProfileAttempting']) || false,
  initialValues: {
    contactPersonName: _get(state, ['user', 'me', 'contactPersonName']),
    address: _get(state, ['user', 'me', 'address']),
    mobile: _get(state, ['user', 'me', 'mobile'])
  }
})
const mapDispatchToProps = (dispatch) => ({
  attemptEditProfile: (data) =>
    dispatch(userActions.attemptEditProfile(data))
})

@connect(mapStateToProps, mapDispatchToProps)
@reduxForm({ form: 'Info', fields: FIELD_NAMES })
class Info extends Component {
  static propTypes = {
    user: PropTypes.object,
    fields: PropTypes.object.isRequired,
    attemptEditProfile: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props)
    this.state = { inputEnabled: false }
  }

  componentDidMount () {
    window.objectFitImages()
  }

  _onSave = () => {
    const { attemptEditProfile, fields: { contactPersonName, address, mobile } } = this.props
    attemptEditProfile({
      contactPersonName: contactPersonName.value,
      address: address.value,
      mobile: mobile.value
    })
  }

  render () {
    const { me, editProfileAttempting, fields: { contactPersonName, address, mobile } } = this.props

    return (
      <section id='info' className={classes.info}>
        <table>
          <tbody>
            <tr>
              <td>อีเมล์</td>
              <td>{_get(me, ['email']) || '-'}</td>
            </tr>
            <tr>
              <td>ชื่อผู้ติดต่อหลัก</td>
              <td>{_get(me, ['contactPersonName']) || '-'}</td>
            </tr>
            <tr>
              <td>ที่อยู่จัดส่ง</td>
              <td>{_get(me, ['address']) || '-'}</td>
            </tr>
            <tr>
              <td>รหัสไปรษณีย์</td>
              <td>{_get(me, ['postalCode']) || '-'}</td>
            </tr>
            <tr>
              <td>เบอร์โทรศัพท์ร้าน</td>
              <td>{_get(me, ['tel']) || '-'}</td>
            </tr>
            <tr>
              <td>เบอร์มือถือ</td>
              <td>{_get(me, ['mobile']) || '-'}</td>
            </tr>
            <tr>
              <td>ชื่อร้าน/บริษัท</td>
              <td>{_get(me, ['pharmacyName']) || '-'}</td>
            </tr>
            <tr>
              <td>เลขที่ใบอนุญาตขายยาหรือประกอบโรคศิลป์</td>
              <td>{_get(me, ['medicalLicenseNo']) || '-'}</td>
            </tr>
            <tr>
              <td>ใบอนุญาตขายยา</td>
              <td><img src={_get(me, ['pharmacyLicensePath'])} alt='ใบอนุญาตขายยา' /></td>
            </tr>
            <tr>
              <td>ใบประกอบวิชาชีพ</td>
              <td><img src={_get(me, ['professionalLicensePath'])} alt='ใบประกอบวิชาชีพ' /></td>
            </tr>
            <tr>
              <td>ชื่อใน Facebook</td>
              <td>{_get(me, ['facebookName']) || '-'}</td>
            </tr>
            <tr>
              <td>ชื่อใน Line</td>
              <td>{_get(me, ['lineId']) || '-'}</td>
            </tr>
          </tbody>
        </table>
        <div className={classes.warning}>
          <span>กรณีต้องการเปลี่ยนแปลงข้อมูลส่วนตัว กรุณาติดต่อเจ้าหน้าที่เพื่อขอเปลี่ยนแปลงข้อมูล</span>
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.inputHeader}>
            <span>ชื่อ-ที่อยู่จัดส่ง</span>
          </div>
          <FormGroup title='ชื่อ'>
            <input type='text' onChange={contactPersonName.onChange} value={contactPersonName.value} />
          </FormGroup>
          <FormGroup title='ที่อยู่'>
            <textarea onChange={address.onChange} value={address.value} />
          </FormGroup>
          <FormGroup title='เบอร์โทร'>
            <input type='text' onChange={mobile.onChange} value={mobile.value} />
          </FormGroup>
          <div style={{ width: 160 }} className={classes.button} onClick={this._onSave}>
            {editProfileAttempting ? <Loader /> : <span>บันทึกชื่อ-ที่อยู่จัดส่ง</span>}
          </div>
        </div>
      </section>
    )
  }
}

export default Info



// WEBPACK FOOTER //
// ./src/containers/User/Profile/Info.js